module.exports = __webpack_public_path__ + "static/media/user.daf65c8e.svg";